export default __webpack_public_path__ + "static/dashboard-thumb-3-a032bcd88bd20f5984da59f0138d0f0e.webp";